import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { ModelSummaryDto } from './getModelsBySearchModelQuery';

const ENDPOINT = `${APIConfiguration.catalog}models`;

export interface GetModelByIdsCommandPayload {
  ids: string[];
}

export const getModelByIdsRequest = (
  payload: GetModelByIdsCommandPayload,
): ApiRequestDescriptor => ({
  url: ENDPOINT,
  config: { method: SUPPORTED_METHODS.POST, json: payload },
});

export const getModelByIdsCommand = async (
  payload: GetModelByIdsCommandPayload,
): Promise<BackResponse<ModelSummaryDto[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<ModelSummaryDto[]>>(
      getModelByIdsRequest(payload),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
